var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E5FDFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#EDFAF6",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.668 11.8333H14.0013C13.6477 11.8333 13.3085 11.9738 13.0585 12.2238C12.8084 12.4739 12.668 12.813 12.668 13.1666V23.8333C12.668 24.1869 12.8084 24.5261 13.0585 24.7761C13.3085 25.0262 13.6477 25.1666 14.0013 25.1666H22.0013C22.3549 25.1666 22.6941 25.0262 22.9441 24.7761C23.1942 24.5261 23.3346 24.1869 23.3346 23.8333V16.5M18.668 11.8333L23.3346 16.5M18.668 11.8333V16.5H23.3346",
    stroke: "#00535C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.aae5c14a.svg";
export { ForwardRef as ReactComponent };